
import './footer.css'

export default function Footer () {
  return (
    <footer className="text-center bg-black text-white py-3">
      <a href={process.env.REACT_APP_API_BASE_URL} target='_blank'>
        <img src="https://gnetworkclub.com/wp-content/uploads/2025/01/gnetwork-logo_orange.svg" alt="GNetwork Logo" className="footer-logo mb-3"/>
      </a>
      <p className="text-gray fs-0.75x copyright">&copy; {new Date().getFullYear()} GNetwork</p>
    </footer>
  )
}
